module.exports = __webpack_public_path__ + "static/media/A2.56af439c.jpg";